module.exports = __webpack_public_path__ + "static/media/star.be973412.svg";